import { render } from "./MenuDialog.vue?vue&type=template&id=4b09b174&scoped=true"
import script from "./MenuDialog.vue?vue&type=script&lang=js"
export * from "./MenuDialog.vue?vue&type=script&lang=js"

import "./MenuDialog.vue?vue&type=style&index=0&id=4b09b174&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b09b174"]])

export default __exports__